
export class ReflectionUtils {

  constructor() {
  }

  static copyAttributes<T>(fromObject: T, toObject: T, ignoreList: string[] = []) {
    const keys = Object.keys(fromObject);
    for (const key of keys) {
      if (ignoreList.includes(key)) {
        continue;
      }
      toObject[key] = fromObject[key];
    }
  }
}
